import { CuentaContable } from "./cuenta-contable";


export class AsientoContableDetalle{
    public constructor(
        public id: String = "",
        public debe: number = 0,
        public haber: number = 0,
        public cuenta_contable_id: String = "",
        public asiento_cuenta_id: String = "",
        public cuenta = new CuentaContable(),
        
      
        public empresa_id: String = "",
        public usuario_id:String = null,
        public status: String = "",

    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/asiento-contable-detalle.ts